import { Component } from '@angular/core';

@Component({
  selector: 'app-open11-info-component',
  imports: [],
  templateUrl: './open11-info-component.html',
  styleUrl: './open11-info-component.scss'
})
export class Open11InfoComponent {

}
